import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ResizeAware from 'react-resize-aware';
import DynamicDataGrid from './DynamicDataGrid/DynamicDataGrid';
import { HJ_DICTIONARY_RECYCLE_VPV } from '../../hotjarConstants';
import { sendVPVHotjarEvent } from '../../util/hotjarUtils';

const recycleGridColumns = [
  { key: 'title', name: 'Title', sortable: true },
  { key: 'keyword', name: 'Code Expression', sortable: true },
];

export default class Recycle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      RecycleElements: this.props.gridData.RecycleElements
        ? [...props.gridData.RecycleElements]
        : [],
    };
    sendVPVHotjarEvent(HJ_DICTIONARY_RECYCLE_VPV);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.gridData.RecycleElements !== nextProps.gridData.RecycleElements
    ) {
      this.setState({ RecycleElements: nextProps.gridData.RecycleElements });
    }
  }

  handleCRBGridsResize = dimensions => {
    this.setState({ CRBGridsWidth: dimensions.width });
  };

  render() {
    return (
      <div className="profile-planner-tabs">
        <div>
          <div>
            <ResizeAware
              style={{ position: 'relative', width: '100%' }}
              onlyEvent
              onResize={this.handleCRBGridsResize}
            >
              <DynamicDataGrid
                gridCategory="RecycleGrid"
                className="recycle-data-grid dictionary-data-grid"
                gridHeight={280}
                gridWidth={this.state.CRBGridsWidth}
                headerRowHeight={28}
                rowHeight={27}
                rows={this.state.RecycleElements}
                columns={recycleGridColumns}
                rowSelectionType="Multi"
                handleAnswersPreview={this.props.handleAnswersPreview}
                isCellSelectable
                isRowsDraggable
                minimunRows={10}
              />
            </ResizeAware>
          </div>
        </div>
      </div>
    );
  }
}

Recycle.propTypes = {
  handleAnswersPreview: PropTypes.func,
  gridData: PropTypes.shape({
    RecycleElements: PropTypes.arrayOf(PropTypes.object),
  }),
};
